import {useAtomValue, useSetAtom} from 'jotai'
import {atomWithStorage} from 'jotai/utils'

// The HttpOnly auth_token cookie is the real credential; this is a UI cache, never a token.
const userIdentifierAtom = atomWithStorage<string | null>('auth_user_identifier', null)

export function useLogged(): boolean {
  return useAtomValue(userIdentifierAtom) !== null
}

export function useUserIdentifier(): string | null {
  return useAtomValue(userIdentifierAtom)
}

export function useSetLogged(): (userIdentifier: string | null) => void {
  return useSetAtom(userIdentifierAtom)
}
